/* * @Description: 预览
 * @Date: 2022-07-27 16:30:41
 */
import { useBiTmplDetailSteup } from '@V/bi-tmpl/src/store';
import { storeToRefs } from 'pinia';
import { topicData } from '../mock/_topics';
import { analysis } from '../mock/_analysis';
import { multiSample } from '../mock/_multi-sample';
import { SCENE_MAPPING } from '../constants/index';
import { isObject } from 'lodash';
import { BI_URL } from '@/config';

export const data_4_1 = {
  resultSystem:
    '根据个案处理摘要显示，“性别”中“男”的个案数为10个，有效百分比为47.62%，缺失个案数为0个，缺失百分比为0.00%，总计个案数为10个，总计个案数百分比为100.00%；“性别”中“女”的有效个案数为11个，有效百分比为52.38%，缺失个案数为0个，缺失百分比为0.00%，总计个案数为11个，总计个案数百分比为100.00%；“年龄”中“18-30岁”的个案数为6个，有效百分比为28.57%，缺失个案数为0个，缺失百分比为0.00%，总计个案数为6个，总计个案数百分比为100.00%，“年龄”中“31-40岁”的有效个案数为8个，有效百分比为38.10%，缺失个案数为0个，缺失百分比为0.00%，总计个案数为8个，总计个案数百分比为100.00%，“年龄”中“41岁以上”的有效个案数为7个，有效百分比为33.33%，缺失个案数为0个，缺失百分比为0.00%，总计个案数为7个，总计个案数百分比为100.00%。',
  resultUser: '',
  table: {
    header: [
      { prop: 'totalType', label: [''], group: true },
      { prop: 'type', label: [''] },
      {
        prop: 'sub',
        label: ['有效'],
        subHeaderList: [
          { prop: 'sub1', label: ['个案数'] },
          { prop: 'sub2', label: ['百分比'] }
        ]
      },
      {
        prop: 'del',
        label: ['个案缺失'],
        subHeaderList: [
          { prop: 'del1', label: ['个案数'] },
          { prop: 'del2', label: ['百分比'] }
        ]
      },
      {
        prop: 'del',
        label: ['总计'],
        subHeaderList: [
          { prop: 'total1', label: ['个案数'] },
          { prop: 'total2', label: ['百分比'] }
        ]
      }
    ],
    value: [
      {
        totalType: ['性别'],
        type: ['男'],
        sub1: ['10'],
        sub2: ['47.62%'],
        del1: ['0'],
        del2: ['0.00%'],
        total1: ['10'],
        total2: ['100.00%']
      },
      {
        totalType: ['性别'],
        type: ['女'],
        sub1: ['11'],
        sub2: ['52.38%'],
        del1: ['0'],
        del2: ['0.00%'],
        total1: ['11'],
        total2: ['100.00%']
      },
      {
        totalType: ['年龄'],
        type: ['18-30岁'],
        sub1: ['6'],
        sub2: ['28.57%'],
        del1: ['0'],
        del2: ['0.00%'],
        total1: ['6'],
        total2: ['100.00%']
      },
      {
        totalType: ['年龄'],
        type: ['32-40岁'],
        sub1: ['8'],
        sub2: ['38.10%'],
        del1: ['0'],
        del2: ['0.00%'],
        total1: ['8'],
        total2: ['100.00%']
      },
      {
        totalType: ['年龄'],
        type: ['41岁以上'],
        sub1: ['7'],
        sub2: ['33.33%'],
        del1: ['0'],
        del2: ['0.00%'],
        total1: ['7'],
        total2: ['100.00%']
      }
    ]
  }
};

export const data_4_3 = {
  resultSystem:
    '本报告样本，项目执⾏⼈共计21⼈。完成1-60单的共计1⼈，占⽐4.76%， 有效占比为4.76%，本次完成的累计百分⽐为 4.76%；完成61-120单的共计2⼈，占⽐9.52%，有效占比为9.52%，本次完成的累计百分⽐为14.28%；完成121-180单的共计3⼈，占⽐ 14.28%，有效占比为14.28%，本次完成的累计百分⽐为28.57%；完成181-240单的共计4⼈，占⽐19.05%，有效占比为19.05%， 本次完成的累计百分⽐为47.62%；完成241-300单的共计11⼈，占⽐52.38%，有效占比为52.38%，本次完成的累计百分⽐为100.00%。',
  resultUser: '',
  echart: {
    '1-60单': ['1'],
    '61-120单': ['2'],
    '121-180单': ['3'],
    '181-240单': ['4'],
    '241-300单': ['11']
  },
  colourGroup: null,
  resultSystemMedian:
    '本报告样本，中位数为“241-300单”，这表示将所有数据从小到大排列后，位于中间位置的数值是“241-300单”；众数为“241-300单”，这表示出现次数最多的数值是众数为“241-300单”；百分位数是描述一组数据中某个特定百分比处的取值。本组数据中“25”百分位数为“21-180单”，“50”百分位数为“241-300单”，“75”百分位数为“241-300单”。',
  medianTable: {
    header: [
      { prop: 'title', label: [''] },
      { prop: 'median', label: ['中位数'] },
      { prop: 'modeNum', label: ['众数'] },
      {
        prop: 'percentileNum',
        label: ['百分位数'],
        subHeaderList: [
          { prop: 'percentileNum25', label: ['25'] },
          { prop: 'percentileNum50', label: ['50'] },
          { prop: 'percentileNum75', label: ['75'] }
        ]
      }
    ],
    value: [
      {
        median: ['241-300单'],
        modeNum: ['241-300单'],
        percentileNum25: ['121-180单'],
        percentileNum50: ['241-300单'],
        percentileNum75: ['241-300单'],
        title: ['项目参与人完成任务的区间分布']
      }
    ]
  },
  table: {
    header: [
      { prop: 'numRange', label: ['选项'] },
      { prop: 'peopleNum', label: ['数量'] },
      { prop: 'rate', label: ['本次占比'] },
      { prop: 'effectivePercentage', label: ['有效占比'] },
      { prop: 'accumulativePercentage', label: ['累计百分比'] }
    ],
    value: [
      {
        numRange: ['1-60单'],
        peopleNum: ['1'],
        rate: ['4.76%'],
        effectivePercentage: ['4.76%'],
        accumulativePercentage: ['4.76%'],
        accumulativePercentage1: ['100.00%']
      },
      {
        numRange: ['61-120单'],
        peopleNum: ['2'],
        rate: ['9.52%'],
        effectivePercentage: ['9.52%'],
        accumulativePercentage: ['14.28%'],
        accumulativePercentage1: ['100.00%']
      },
      {
        numRange: ['121-180单'],
        peopleNum: ['3'],
        rate: ['14.28%'],
        effectivePercentage: ['14.28%'],
        accumulativePercentage: ['28.57%'],
        accumulativePercentage1: ['100.00%']
      },
      {
        numRange: ['181-240单'],
        peopleNum: ['4'],
        rate: ['19.05%'],
        effectivePercentage: ['19.05%'],
        accumulativePercentage: ['47.62%'],
        accumulativePercentage1: ['100.00%']
      },
      {
        numRange: ['241-300单'],
        peopleNum: ['11'],
        rate: ['52.38%'],
        effectivePercentage: ['52.38%'],
        accumulativePercentage: ['100.00%'],
        accumulativePercentage1: ['100.00%']
      }
    ]
  },
  resultUserMedian: ''
};

const randomChartType = (chartTypeList: string) => {
  try {
    const list = chartTypeList.split(',');
    return list[parseInt(Math.random() * list.length)];
  } catch (error) {
    return chartTypeList;
  }
};

export default () => {
  const store = useBiTmplDetailSteup();
  const { state } = storeToRefs(store);

  let baseId = 1;
  const getId = () => (baseId += 1);

  const HOT_MAP_LIST = [
    'CONTENT_HIT_RATE_RANKING_MAP',
    'ZONE_HISTORY_EVALUATION_HOT',
    'ZONE_EVALUATION_CURRENT_HOT'
  ];
  const getChartType = item => {
    // 有效点击分布区域热力图;
    if (HOT_MAP_LIST.includes(item.modelType)) {
      return 100;
    }

    return isObject(item.value)
      ? (Object.values(item.value)[0] as any).value
      : item.value;
  };
  const getTableType = item => {
    // 有效点击分布区域热力图;
    if (HOT_MAP_LIST.includes(item.modelType)) {
      return item.value;
    }

    return isObject(item.value)
      ? (Object.values(item.value)[1] as any).value
      : null;
  };

  /**   * @description: 该预览只处理了一个内容预览，背景/流程
   */
  const onPreview = () => {
    const baseTemplates = {
      '1': {
        title: '项目背景介绍',
        presentContent: `
        <p>糖尿病治疗的趋势包括以下几个方面:</p>
        <p>1.个体化治疗:现代糖尿病治疗越来越注重个体化，根据患者的病情、生活方式、食物偏好等个体差异制定个性化的治疗方案。</p>
        <p>2.药物研发和创新:随着科技的进步，新型糖尿病药物的研发不断涌现，如GLP-1受体激动剂、SGLT-2抑制剂等。这些药物具有更好的降糖效果、减少低血糖风,险等优势。</p>
        <p>3.技术应用:借助智能设备、医疗器械等技术手段，患者可以更方便地监测血糖、控制饮食和锻炼等。例如，通过连续血糖监测系统，患者可以实时了解自己的血糖状况，调整治疗方案。</p>
        <p>4.综合管理:糖尿病治疗已经从单纯的药物治疗拓展为综合管理，包括生活方式干预、血糖控制、心血管风险管理等。这种综合治疗的方法可以减少糖尿病并发症的风险。</p>
        `,
        style: state.value.menuValue.get('1')?.value,
        info: '1920年代初期，科学家们鉴定并纯化了一种胰腺提取物 一胰岛素，1922年，14岁的1型糖尿病患者Leonard Thompson接受了胰岛责注射并且获得症状改善。研究人员在1922年发表的论文中指出，这些结果无疑表明胰腺提取物对于某些1型糖尿病患者来说具有治疗价值。随后，胰岛素被成功用于调节1型糖尿病患者的血糖水平，彻底改变了这些患者的治疗方式。1923年，FrederickBanting医生与生理学家John Macleod因为对胰岛素的研究获得诺贝尔生理学或医学奖。胰岛素的发现给糖尿病患者的治疗带来了革命性的变化，但是糖尿病的病理生理学机制在随后几十年里却仍然未能得到澄清。',
        isHave: 1
      },
      '2': {
        title: '项目样本采集范围',
        isSetContent: 1,
        projectProductContent:
          '乳康舒胶囊一般是指乳疼消片，出现乳腺增生、乳腺资等疾病时可以使用。乳庭消片是一种中成药制剂，主要成分是鹿角、当归等药物组蒲公英、昆布、干不留行、木香、夏枯草、组成。',
        projectProductPicUrl: '',
        projectDiseaseKeyword:
          '窦失性心动过速;新烧生儿氧缺血性缺;慢性阻塞性肺疾病急性;功肾能衰减肾小球肾炎;小儿暑中和热暑症',
        style: state.value.menuValue.get('2')?.value,
        content: `
        <p style="font-weight:bold;">调研目的</p>
        <p>乳腺瘤无进展生存期及生活质量调研。</p>
        <p style="font-weight:bold;">调研人群</p>
        <p>乳腺病患者</p>
        `,
        isShow: 0,
        projectPrefaceContent: `
        <p>乳腺病的前沿治疗方法相较于传统的手术治疗和放疗，主要包括化学药物治疗、内分沙治疗和向治疗等，具体如下:</p>
        <p>1.化学药物治疗:其目的是通过药物来缩小病灶，减少癌细胞。常用化疗药物包括多柔比星表柔比星、紫杉醇、多西他赛等，但要根据对药物的敏,感程喜以及化疗后的效果来选择</p>
        <p>2.内分沙治疗:其主要的作用是通过抑制或阳断激索来达到治疗目的。可使用抗难激衰药物如托瑞米芬、他莫首芬等，也可以使用芳香酶抑制剂，如来曲哇、阿那曲哗等.</p>
        `,
        isHave: 0
      },
      '3': {
        title: '项目总览',
        aspName: '服务商：同凌医疗科技有限公司',
        dataSum: 50,
        isShowUserSum: 1,
        demandName:
          '关于双鲸维生素E胶囊(天然型)产品在青海地区的零售药店巡店项目',
        gongyeName: '项目方：盛安制药有限公司',
        demandLocation: '全国',
        submitTime: '2022-05-05',
        price: '300W以上',
        chartType: state.value.menuValue.get('3')?.value,
        userSum: 50,
        executeTime: '2021-08-01 - 2022-07-31',
        demandDesc:
          '我司现需要服务商针对关于阿莫西林产品在全国地区的零售药店巡店项目服务。',
        isHave: 1
      },
      '4': {
        title: '项目执行人数据统计',
        peopleGenderData: {
          resultSystem: null,
          resultUser: null,
          echart: { 男性: ['10'], 女性: ['11'] },
          chartType:
            state.value.menuValue.get('4')?.value['4_2'].value['4_2_1'].value,
          table: null
        },
        projectPeopleAgeAnalysis: {
          resultSystem:
            '本报告样本，项目执⾏⼈共计21⼈。男性⼈数为10⼈，占⽐47.62%；⼥性⼈数为11⼈，占⽐为52.38%。18-30岁之间男性⼈数为3⼈，占⽐ 14.28%。⼥性⼈数为3⼈，占⽐14.28%；31-40岁之间男性⼈数为4，占⽐19.05%。⼥性⼈数为4，占⽐19.05%；41岁以上男性⼈数为3⼈，占 ⽐14.28%。⼥性为4⼈，占⽐19.05%。',
          resultUser: '',
          echart: {
            '18-30岁': ['3', '3'],
            '31-40岁': ['4', '4'],
            '41岁以上': ['3', '4']
          },
          chartType: randomChartType(
            state.value.menuValue.get('4')?.value['4_2'].value['4_2_2'].value
          ),
          colourGroup: null,
          table: null
        },
        taskFinishData: {
          ...data_4_3,
          chartType: randomChartType(
            state.value.menuValue.get('4')?.value['4_3'].value['4_3_1'].value
          ),
          chartTypeList:
            state.value.menuValue.get('4')?.value['4_3'].value['4_3_1'].value,
          percentageStyle:
            state.value.menuValue.get('4')?.value['4_3'].value['4_3_2'].value,
          medianStyle:
            state.value.menuValue.get('4')?.value['4_3'].value['4_3_3'].value
        },
        peopleBeforeData: {
          ...data_4_1,
          chartType: state.value.menuValue.get('4')?.value['4_1'].value
        },
        projectPeopleMenAgeDistribute: {
          resultSystem: null,
          resultUser: null,
          echart: { '18-30岁': ['3'], '31-40岁': ['4'], '41岁以上': ['3'] },
          chartType: randomChartType(
            state.value.menuValue.get('4')?.value['4_2'].value['4_2_3'].value
          ),
          colourGroup: null,
          table: null
        },
        projectPeopleWomenAgeDistribute: {
          resultSystem: null,
          resultUser: null,
          echart: { '18-30岁': ['3'], '31-40岁': ['4'], '41岁以上': ['4'] },
          chartType: randomChartType(
            state.value.menuValue.get('4')?.value['4_2'].value['4_2_4'].value
          ),
          colourGroup: null,
          table: null
        }
      },
      '5': {
        title: '项目相关分析模块',
        topics: state.value.menuValue
          .get('5')
          ?.value['5_2'].value.split(',')
          .map((chartType: string, index: number, arr: Array<any>) => ({
            ...topicData[index % topicData.length],
            id: getId(),
            chartType: chartType,
            medianChartType: state.value.menuValue.get('5').value['5_4'].value,
            tableChartType: state.value.menuValue.get('5').value['5_3'].value,
            topicType: index + 1 == arr.length ? 2 : 1
          })),
        chartType: state.value.menuValue.get('5')?.value['5_1'].value,
        userSum: 21,
        isShowUserSum: 1,
        topicSum: 30,
        analysisDimen: '主体分析',
        isHave: 1
      },
      '6': {
        title: '交叉分析表与卡方分析',
        analysisMethodDescription:
          '本模块采用卡方检验作为分析方法，主要用于两组样本或是两个分类变量之间差异性的分析。其根本思想是利用样本的实际频数和理论频数的吻合度，来判断样本是否符合预期。',
        analysisResult: state.value.menuValue
          .get('6')
          ?.value['6_2'].value.split(',')
          .map((type: string, index: number) => {
            const data = analysis[index % analysis.length];
            return {
              ...data,
              kafangObj: {
                ...(data?.kafangObj || {}),
                chartType: type,
                chartTableTypeV3:
                  state.value.menuValue.get('6').value['6_3'].value,
                tableTypeV3: state.value.menuValue.get('6').value['6_1'].value
              },
              id: index,
              chartType: type
            };
          }),
        isHave: 1
      },
      '7': {
        title: '单因素与多样本比较',
        chartType: state.value.menuValue.get('7')?.value,
        tables: multiSample,
        isHave: 1
      },
      '8': {
        title: '示例分享',
        imageUrls: new Array(15).fill(0).map((_, index) => {
          return {
            id: index,
            imageUrl: `https://cdn.yxvzb.com/WEB/SaaS/bi-v3/images/hot/${
              index + 1
            }.png`
          };
        }),
        imageSize: 2,
        imageStyle: 2
      },
      '9': {
        title: '项目执行流程',
        content: state.value.menuValue.get('9')?.show
          ? 'https://cdn.yxvzb.com/WEB/SaaS/bi-v3/images/1.jpg'
          : ''
      },
      '10': {
        title: '项目执行进度',
        style: state.value.menuValue.get('10')?.value,
        content: ['2021年12月', '2021年12月-2023年12月', '2024年01月']
      },
      '16': {
        title: '相关性热图',
        pList: JSON.parse(
          `
          [{"v":"0.38","x":0,"y":0},{"v":"0.42","x":1,"y":0},{"v":"0.42","x":0,"y":1},{"v":"0.52","x":2,"y":0},{"v":"0.52","x":0,"y":2},{"v":"0.49","x":3,"y":0},{"v":"0.49","x":0,"y":3},{"v":"0.15","x":4,"y":0},{"v":"0.15","x":0,"y":4},{"v":"0.00","x":5,"y":0},{"v":"0.00","x":0,"y":5},{"v":"0.28","x":1,"y":1},{"v":"0.80","x":2,"y":1},{"v":"0.80","x":1,"y":2},{"v":"0.89","x":3,"y":1},{"v":"0.89","x":1,"y":3},{"v":"0.00","x":4,"y":1},{"v":"0.00","x":1,"y":4},{"v":"0.36","x":5,"y":1},{"v":"0.36","x":1,"y":5},{"v":"0.73","x":2,"y":2},{"v":"0.00","x":3,"y":2},{"v":"0.00","x":2,"y":3},{"v":"0.17","x":4,"y":2},{"v":"0.17","x":2,"y":4},{"v":"0.61","x":5,"y":2},{"v":"0.61","x":2,"y":5},{"v":"0.52","x":3,"y":3},{"v":"0.98","x":4,"y":3},{"v":"0.98","x":3,"y":4},{"v":"0.98","x":5,"y":3},{"v":"0.98","x":3,"y":5},{"v":"0.60","x":4,"y":4},{"v":"0.03","x":5,"y":4},{"v":"0.03","x":4,"y":5},{"v":"0.22","x":5,"y":5}]
          `
        ),

        pResult: `
        <p>如果P值很小（通常认为小于0.05或0.01），这意味着两个变量之间的相关性是显著的，即它们之间存在一定的关联。这种关联可能是正相关或负相关，具体取决于斯皮尔曼相关系数的值。如果P值大于0.05，这意味着两个变量之间的相关性不显著，即它们之间没有明显的关联。这可能是因为数据量不足、样本偏差或其他原因导致的结果。</p>
        `,
        attachmentIsShow: state.value.menuValue.get('16')?.value,
        attachmentList: [
          { keyword: 'A', title: '性别' },
          { keyword: 'B', title: '工作强度' },
          { keyword: 'C', title: '症状' },
          { keyword: 'D', title: '非药物治疗' },
          { keyword: 'E', title: '不良反应' },
          { keyword: 'F', title: '身体锻炼' }
        ],
        rResult: `
        <p>斯皮尔曼相关系数的数值代表两个变量之间的相关强度和方向。范围是从-1到+1。如果相关系数为正，表示当一个变量增加时，另一个变量也倾向于增加。如果相关系数为负，表示当一个变量增加时，另一个变量倾向于减少。相关系数的绝对值越大，表示两个变量之间的相关性越强。当相关系数的绝对值接近1时，表示两个变量之间存在完全的单调关系；当相关系数的绝对值接近0时，表示两个变量之间几乎没有任何相关性。</p>
        `,
        rList: JSON.parse(
          `
          [{"v":"0.56","x":0,"y":0},{"v":"0.58","x":1,"y":0},{"v":"0.58","x":0,"y":1},{"v":"0.93","x":2,"y":0},{"v":"0.93","x":0,"y":2},{"v":"0.97","x":3,"y":0},{"v":"0.97","x":0,"y":3},{"v":"0.01","x":4,"y":0},{"v":"0.01","x":0,"y":4},{"v":"1.00","x":5,"y":0},{"v":"1.00","x":0,"y":5},{"v":"0.96","x":1,"y":1},{"v":"0.98","x":2,"y":1},{"v":"0.98","x":1,"y":2},{"v":"0.95","x":3,"y":1},{"v":"0.95","x":1,"y":3},{"v":"1.00","x":4,"y":1},{"v":"1.00","x":1,"y":4},{"v":"0.09","x":5,"y":1},{"v":"0.09","x":1,"y":5},{"v":"0.52","x":2,"y":2},{"v":"1.00","x":3,"y":2},{"v":"1.00","x":2,"y":3},{"v":"0.31","x":4,"y":2},{"v":"0.31","x":2,"y":4},{"v":"0.40","x":5,"y":2},{"v":"0.40","x":2,"y":5},{"v":"0.06","x":3,"y":3},{"v":"0.11","x":4,"y":3},{"v":"0.11","x":3,"y":4},{"v":"0.35","x":5,"y":3},{"v":"0.35","x":3,"y":5},{"v":"0.24","x":4,"y":4},{"v":"0.31","x":5,"y":4},{"v":"0.31","x":4,"y":5},{"v":"0.43","x":5,"y":5}]
          `
        )
      },
      '18': {
        title: '专区历史数据浏览效果评价',
        topics:
          state.value.menuValue.get('18') &&
          Object.values(state.value.menuValue.get('18').value).map(
            (item: any) => {
              return {
                id: getId(),
                title: item.title,
                chartType: getChartType(item),
                tableType: getTableType(item),
                moduleType: item.modelType,
                colourGroup: null,
                echart: {
                  '2025-09-05': [10],
                  '2025-09-07': [5],
                  '2025-09-09': [1]
                },
                table: {
                  header: [
                    { label: ['省份'], prop: 'province' },
                    { label: ['有效点击率'], prop: 'valid' }
                  ],
                  value: [
                    {
                      province: ['2025-09-05'],
                      valid: [0]
                    }
                  ]
                },
                topicCountInfos: [
                  { countNum: 0, time: 1757030400000, xTopicName: '2025-09-05' }
                ]
              };
            }
          )
      },
      '19': {
        title: '本次专区反馈效果评价',
        topics:
          state.value.menuValue.get('19') &&
          Object.values(state.value.menuValue.get('19').value).map(
            (item: any) => {
              return {
                id: getId(),
                title: item.title,
                chartType: getChartType(item),
                tableType: getTableType(item),
                moduleType: item.modelType,
                colourGroup: null,
                echart: {
                  '2025-09-05': [10],
                  '2025-09-07': [5],
                  '2025-09-09': [1]
                },
                table: {
                  header: [
                    { label: ['省份'], prop: 'province' },
                    { label: ['有效点击率'], prop: 'valid' }
                  ],
                  value: [
                    {
                      province: ['2025-09-05'],
                      valid: [0]
                    }
                  ]
                },
                topicCountInfos: [
                  { countNum: 0, time: 1757030400000, xTopicName: '2025-09-05' }
                ]
              };
            }
          )
      },
      '20': {
        title: '推广相关问卷数据分析',
        analysisResult:
          state.value.menuValue.get('20') &&
          [state.value.menuValue.get('20')].map(item => {
            return {
              author: '潜水员',
              content:
                '<p>8月18日，赵雅芝影迷会发文：苏州演唱会期间，芝姐收到大家递送的400多封信件，她将每一封都全部亲自带回了香港。她用大半个月的时间，一封一封认真读完，再为大家签名。目前这一批信件正陆续安排寄回，由于数量太大，整理工作需要一定时间，请大家耐心等待。</p>',
              picUrl:
                'https://cdn.myxrk.com/myxrk-v2/houtai/test/Be/1755582547918O/ec231b85-17b0-4896-865e-5b856162a07f.jpg',
              title: '牛黄解毒片',
              topic: [
                {
                  chartList: item.value,
                  chartType: item.value.split(',')[0],
                  colourGroup: null,
                  echart: {
                    '2025-09-05': [10],
                    '2025-09-07': [5],
                    '2025-09-09': [2],
                    '2025-09-10': [1],
                    '2025-09-23': [156]
                  },
                  resultSystem:
                    '参与【此题为多选（点击编辑题干）】调查的1个样本。选择答案【选项1】有0个，占比0%选择答案【选项2】有1个，占比100.00%选择答案【选项3】有0个，占比0%选择答案【选项4】有0个，占比0.00',
                  topicAnswerList: [],
                  topicTitle: '此题为多选（点击编辑题干）'
                }
              ]
            };
          })
      },
      '21': {
        title: '各篇内容有效点击量排名',
        topics:
          state.value.menuValue.get('21') &&
          Object.values(state.value.menuValue.get('21').value).map(
            (item: any) => {
              return {
                id: getId(),
                title: item.title,
                chartType: getChartType(item),
                tableType: getTableType(item),
                moduleType: item.modelType,
                colourGroup: null,
                echart: {
                  '2025-09-05': [10],
                  '2025-09-07': [5],
                  '2025-09-09': [1]
                },
                table: {
                  header: [
                    { label: ['省份'], prop: 'province' },
                    { label: ['有效点击率'], prop: 'valid' }
                  ],
                  value: [
                    {
                      province: ['2025-09-05'],
                      valid: [0]
                    }
                  ]
                },
                topicCountInfos: [
                  { countNum: 0, time: 1757030400000, xTopicName: '2025-09-05' }
                ]
              };
            }
          )
      },
      '22': {
        title: '单篇内容有效点击量分析图',
        topics:
          state.value.menuValue.get('22') &&
          [state.value.menuValue.get('22')].map((item: any) => {
            return {
              id: getId(),
              title: item.title,
              chartList: item.value,
              chartType: item.value.split(',')[0],
              tableType: null,
              moduleType: item.modelType,
              colourGroup: null,
              echart: {
                '2025-09-05': [10],
                '2025-09-07': [5],
                '2025-09-09': [1]
              },
              table: {
                header: [
                  { label: ['省份'], prop: 'province' },
                  { label: ['有效点击率'], prop: 'valid' }
                ],
                value: [
                  {
                    province: ['2025-09-05'],
                    valid: [0]
                  }
                ]
              },
              topicCountInfos: [
                { countNum: 0, time: 1757030400000, xTopicName: '2025-09-05' }
              ]
            };
          })
      }
    };
    const templates = SCENE_MAPPING[state.value.sceneType].content.reduce(
      (obj, key) => {
        const curModel = state.value.menuValue.get(key);
        const modelType = curModel.modelType || curModel.rootType; // 项目执行人数据统计多个子模块使用rootType
        const templateValue = baseTemplates[key];
        // 仅添加展示的模块
        if (curModel.show) {
          obj[modelType] = templateValue;
        }
        return obj;
      },
      {}
    );
    const previewData = {
      getCatalogue: {
        modelList: Object.keys(templates).map(key => {
          return {
            modelType: key,
            isHave: 1 // templates已经过滤展示的模块，所以直接返回即可
          };
        })
      },
      ...templates,
      config: {
        projectType: 20,
        selectType: 201,
        isPrint: true,
        isEdit: false,
        platform: 'asp',
        height: 1500,
        isPreview: false,
        sampleLoading: true,
        isV2: false,
        isAchievements: false,
        biV3: 1,
        bigTitle: state.value.menuValue.get('101').value['101_2'].value,
        smallTitle: state.value.menuValue.get('101').value['101_3'].value,
        directory: state.value.menuValue.get('103').value,
        pageNo: state.value.menuValue.get('101').value['101_4'].value,
        themeColor: state.value.menuValue.get('101').value['101_1'].value,
        projectId: 12700
      },
      getCover: {
        cover: state.value.menuValue.get('102').value,
        themeColor: state.value.menuValue.get('101').value['101_1'].value,
        time: '2022-06-17',
        projectName: '关于阿莫西林产品在全国区域的患者诊疗现状调研项目',
        mainPageEnterpriseName: '项目方：盛安制药有限公司',
        fenpeiCode: 'GSD1234567890123456'
      }
    };
    console.log('state.value', state.value);
    console.log('previewData', previewData);

    const biWin = window.open(BI_URL + '?isPreview=1');
    const listenter = e => {
      if (e.data === 'biLoaded') {
        biWin.postMessage({ type: 'biMessage', data: previewData }, '*');
        window.removeEventListener('message', listenter);
      }
    };
    window.addEventListener('message', listenter);
  };
  return { onPreview };
};
